import { useEffect } from "react";
import NavBar from "@/components/NavBar";
import Hero from "@/components/sections/Hero";
import WhyCompass from "@/components/sections/WhyCompass";
import HowItWorks from "@/components/sections/HowItWorks";
import Safety from "@/components/sections/Safety";
import FAQ from "@/components/sections/FAQ";
import FinalCTA from "@/components/sections/FinalCTA";
import { SignupProvider } from "@/context/SignupContext";
import { captureRefFromUrl } from "@/lib/referral";

export default function Landing() {
  useEffect(() => {
    captureRefFromUrl();
  }, []);

  return (
    <SignupProvider>
      <div data-testid="landing-page" className="min-h-screen bg-[#FDFBF7] text-[#1A1A1A]">
        <NavBar />
        <main>
          <Hero />
          <WhyCompass />
          <HowItWorks />
          <Safety />
          <FAQ />
          <FinalCTA />
        </main>
      </div>
    </SignupProvider>
  );
}
